import React, { useEffect, useState } from 'react';
import { Grid, Box, Modal, Typography, Button, LinearProgress } from "@mui/material";
import { styles } from "./styles";
import CloseIcon from '@mui/icons-material/Close';
import { deleteDevice } from 'apis/device';

interface DeleteDeviceProps {
  open: boolean;
  handleClose: Function | any;
  device: { name: string, id: number } | null;
  getDevice: Function;
}


const DeleteDeviceModal: React.FC<DeleteDeviceProps> = ({ open, handleClose, device, getDevice }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");

  console.log(device);

  const handleDeleteDevice = async () => {
    setErr("");
    setIsLoading(true);
    if (device !== null) {
      let data = await deleteDevice(device.id);
      console.log(data);
      if (data?.response?.data?.errorMessage) {
        setIsLoading(false);
        setErr(data.response.data.errorMessage);
        return
      }
      if (data) {
        setIsLoading(false);
        handleClose(false);
        getDevice();
      }
    } else {
      setIsLoading(false);
      handleClose(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <>
        <Box sx={{...styles.container, height: "max-content"}}>
          {isLoading && <LinearProgress sx={{ margin: ".5rem 0" }} />}
          {err !== "" && <Typography sx={{color: "red", fontSize: ".7rem"}}>{err}</Typography>}
          <Grid item xs={12} sx={styles.header}>
            <h2>Delete Device</h2>
            <CloseIcon onClick={() => handleClose(false)} />
          </Grid>
          <Grid item xs={12}>
            <Typography>Are you sure you want to delete device {device !== null && device.name}?</Typography>
          </Grid>

          <Grid item xs={12} sx={styles.buttonContainer}>
            <Button sx={styles.cancelButton} onClick={() => handleClose(false)}>No</Button>
            <Button sx={styles.addButton} onClick={() => handleDeleteDevice()}>Yes</Button>
          </Grid>
        </Box>
      </>
    </Modal>
  )
}

export default DeleteDeviceModal;
